const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "16px",
    marginBottom:"8px"
  },

  btn: {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer",
    color: "#705ed4",
    fontWeight: "500",
  },

  active: {
    background: "#705ed4",
    color: "#fff",
    border: "none",
  },
};

export function Pagination({ page, total_pages, onPageChange }) {
  return (
    <div style={styles.container}>
      <button
        style={styles.btn}
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
      >
        Prev
      </button>

      {Array.from({ length: total_pages }, (_, i) => i + 1).map(
        (pg) => (
          <button
            key={page}
            style={{
              ...styles.btn,
              ...(pg === page ? styles.active : {}),
            }}
            onClick={() => onPageChange(pg)}
          >
            {pg}
          </button>
        )
      )}

      <button
        style={styles.btn}
        onClick={() => onPageChange(page + 1)}
        disabled={page === total_pages}
      >
        Next
      </button>
    </div>
  );
};